import { render, staticRenderFns } from "./VDynamicModalConfirm.vue?vue&type=template&id=6c7e4ce5&"
import script from "./VDynamicModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./VDynamicModalConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports